import { Component } from '@angular/core';
import { Router ,ActivatedRoute, NavigationEnd} from '@angular/router';
import {UserService} from '../../../app/services/user.service'
@Component({
  selector: 'app-agent-payment-cancel',
  templateUrl: './agent-payment-cancel.component.html',
  styleUrls: ['./agent-payment-cancel.component.css']
})
export class AgentPaymentCancelComponent {
  constructor(private router: Router,private UserService:UserService ,
    private route: ActivatedRoute) {

      let currentRoute:any;
      currentRoute = this.router?.routerState?.snapshot?.url;
      this.route.paramMap.subscribe(params => {
       let id= params.get('token');
       if(id){
       this.paymentOrderData(id)
       }
      });

    }

  goBack() {
let path:any=sessionStorage.getItem('urlAgentPath')
// console.log(path)
window.location.href=path

    // this.router.navigate([path]); // Navigate to the homepage or any other route
  }
  countdown: number = 20;
interval: any;
ngOnInit(): void {
  this.startTimer();
}

confirmationData:any
paymentOrderData(orderID:any){
  
    this.UserService.paymentOrderData(orderID)
    .subscribe({
      next : (res:any) => {
        if(res) {
  this.confirmationData=res
        } else {
        } 
      },error : (err) => {
  
      }
    }
  )
  
  
  }


startTimer(): void {
  this.interval = setInterval(() => {
    if (this.countdown > 0) {
      this.countdown--;
    } else {
      this.goBack()
      clearInterval(this.interval);
      // Timer has completed. You can add more logic here if needed.
    }
  }, 1000); // 1000 milliseconds = 1 second
}
}
